import { http } from '../../services/baseService'
import { CheckoutStates } from '../../constants/checkoutStates'
import store from '../../core/store'
import { setCheckoutFinishedSuccess } from '../../reducers/orderSlice'

const Linx = function (paymentGateway) {
  this.paymentGateway = paymentGateway
  this.quote = null
  this.productIds = null
  this.orderId = null
  this.lang = 'es'

  this.createQuote = ({ order, productsList, store }) => {
    this.lang = store.lang ?? this.lang
    this.orderId = order.id
    this.quote = {
      items: order.orderDetails.map((detail) => {
        return {
          ProductID: productsList.find((product) =>
            product.skus.some((sku) => sku.id == detail.product.skuId),
          ).id,
          SkuID: detail.product.skuId,
          Quantity: detail.product.quantity,
        }
      }),
    }
  }

  this.startCheckout = async () => {
    let response
    try {
      response = await http.post('/api/orders/startLinx', {
        paymentGateway: paymentGateway,
        orderId: this.orderId,
        quote: this.quote,
      })
    } catch (err) {
      console.error(err)
      // core devuelve 409 cuando la tienda no armó el carrito con lo pedido: un SKU
      // inválido o, el caso realista, un talle que se agotó entre el vivo y el
      // checkout. Está medido que la tienda no recorta la cantidad, descarta el
      // agregado completo, así que el comprador no puede seguir -- pero al menos ve
      // el cartel de stock en vez de volver atrás sin ninguna explicación.
      this.checkoutInitializeStatus =
        err.response?.status === 409
          ? CheckoutStates.INSUFFICIENT_STOCK
          : CheckoutStates.NOT_INITIALIZED
      return this.checkoutInitializeStatus
    }

    const { basketId, checkoutUrl } = response.data?.preference ?? {}

    // Sin estos dos datos no hay a dónde redirigir. Antes se seguía igual y el
    // redirector terminaba haciendo POST a la URL literal "undefined", o sea el
    // comprador caía en una página muerta con 405 en vez de ver el error.
    if (!basketId || !checkoutUrl) {
      console.error('startLinx respondió sin datos de checkout', response.data)
      this.checkoutInitializeStatus = CheckoutStates.NOT_INITIALIZED
      return this.checkoutInitializeStatus
    }

    this.basketId = basketId
    this.checkoutUrl = checkoutUrl
  }

  this.goToCheckout = ({ checkoutWindow }) => {
    // Guarda por si algún camino llega acá sin haber podido iniciar el checkout:
    // mejor cerrar la ventana que dejar al comprador en una página muerta.
    if (!this.checkoutUrl) {
      checkoutWindow?.close?.()
      return
    }

    const redirectUrl = new URL(`${window.location.origin}/linx/redirect`)
    redirectUrl.searchParams.append('BasketID', this.basketId)
    redirectUrl.searchParams.append('CheckoutURL', this.checkoutUrl)
    redirectUrl.searchParams.append('lang', this.lang)
    checkoutWindow.location.href = redirectUrl
    checkoutWindow.focus()
    store.dispatch(setCheckoutFinishedSuccess(true))
  }
}

export default Linx
